import { ff } from '@atlassian/jira-feature-flagging';

export const isJsmTimelineEnabled = (): boolean => ff('jsm-timelines-phase-2_70gja', false);

export const isCannedResponseFFEnabled = () => ff('jsm-canned-response', false);
